import { PageRouteDef } from '@core/types'
import { orderingPages } from 'src/business/ordering/orderingPages'
import { staticPages } from 'src/business/static-pages/staticPages'
import { myZonePages } from 'src/business/my-zone/myZonePages'
import { warehousePages } from 'src/business/Warehouse/WarehousePages'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const routes = require('src/routing/routes').default

export type PageNavItem = [string, PageRouteDef<any>]
// TODO group other pages
export const pages = {
    LandingWebView: {
        path: routes.landingWebview.path,
        comp: () => import('../business/landing-page/LandingPageMobileView'),
        to: (): string => routes.landingWebview.path
    },
    Landing: {
        path: routes.landing.path,
        comp: () => import('src/business/landing-page/LandingPage'),
        to: (): string => routes.landing.path
    },
    ServiceAccess: {
        path: routes.serviceAccess.path,
        comp: () => import('src/business/ServiceAccess/ServiceAccessPage'),
        to: (): string => routes.serviceAccess.path
    },
    QrAccess: {
        path: routes.qrAccess.path,
        comp: () => import('src/business/QrAccess/QrAccessPage'),
        to: (): string => routes.qrAccess.path
    },
    ...warehousePages,
    ...orderingPages,
    ...staticPages,
    ...myZonePages,
    Login: {
        path: routes.login.path,
        comp: () => import('src/auth/LoginPage'),
        to: (redirectPath?: string): string => {
            let r = routes.login.path
            if (redirectPath) r = r + `?redirect=${redirectPath}`

            return r
        },
        params: {
            redirect: 'redirect'
        }
    },
    Registration: {
        path: routes.registration.path,
        comp: () => import('src/auth/registration/RegistrationPage'),
        to: (): string => routes.registration.path
    },
    ResetPasswordRequest: {
        path: routes.resetPasswordRequest.path,
        comp: () => import('src/auth/reset-password/ResetPasswordRequestPage'),
        to: (): string => routes.resetPasswordRequest.path
    },
    ResetPasswordChange: {
        path: routes.resetPasswordChange.path,
        comp: () => import('src/auth/reset-password/ResetPasswordChangePage'),
        to: (): string => routes.resetPasswordChange.path
    }
}

export const pageList: PageRouteDef<any>[] = Object.values(pages)
